export enum TestResultEnum {
  Negative = "Negative",
  WeakPositive = "WeakPositive",
  Positive = "Positive",
  Inconclusive = "Inconclusive",
}
